module.exports = __webpack_public_path__ + "img/port-ph2.c8c2f12b.jpg";